import React, { useState } from "react";
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, DropdownButton, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useRouteLoaderData } from "react-router-dom";

import { useRequest } from "@components/AppHook";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { Awesome, DevModal, OverflowArea } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { SimplePaginator } from "@components/Paginator";
import { buildQS, parseQS, scroll_to_top, url_reverse } from "@components/Utils";
import { getGemHost } from "@vkplay/shared";

export default function ModerateCommunityScreen() {
    return (
        <DefaultLayout>
            <ModerateCommunity />
        </DefaultLayout>
    );
}

function ModerateCommunity() {
    const { t } = useTranslation();
    const [apiData, setApiData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const { api_get } = useRequest();

    const defParams = parseQS();
    if (!["0", "1"].includes(defParams.hide_smm)) {
        defParams.hide_smm = "1";
    }
    const [formData, setFormData] = useState(defParams);
    const { ext_api_get, ext_api_post } = useRequest();

    const commonInfo = useRouteLoaderData("commonInfo");
    const communityHost = getGemHost("community");
    const adminHost = getGemHost("admin").replace("vkplay.ru", "my.games");
    const profileUrl = `https://${adminHost}/admin/?login=`;

    const handleFormChange = (obj) => {
        const newFormData = { ...formData };
        Object.entries(obj).forEach(([k, v]) => {
            newFormData[k] = v;
        });
        setFormData(newFormData);
    };

    const doSearch = (p) => {
        handleFormChange({ page: p });
        const qs = buildQS({ ...formData, page: p });
        ext_api_get("search", `/community/moderation_feed_get?${qs}`, {
            then: (resp) => {
                setApiData(resp);
                scroll_to_top();
            },
        });
    };

    const doDelete = (ev) => {
        apiData.data.feed.forEach((item) => {
            if (item.chosen) {
                ext_api_post(ev, `/community/post_hide`, {
                    params: { id: item.post_id },
                    then: (resp) => {
                        if (resp.status === "ok") {
                            setShowModal(false);
                            doSearch(formData.page);
                        }
                    },
                });
            }
        });
    };

    return (
        <Card>
            <Card.Header>
                {t("Коммьюнити")}
                <div className="dmg-card-header-tools">
                    <DropdownButton as={ButtonGroup} size="sm" variant="dark" title={t("С выбранными")}>
                        <Dropdown.Item onClick={() => setShowModal("item")}>{t("Удалить")}</Dropdown.Item>
                    </DropdownButton>
                </div>
            </Card.Header>
            <Card.Body>
                <DevModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    body={t("Подтвердите удаление")}
                    footer={
                        <>
                            <Button variant="light" onClick={() => setShowModal(false)}>
                                {t("Закрыть")}
                            </Button>
                            <DevForm.Button variant="danger" name="delete" onClick={doDelete}>
                                {t("Удалить")}
                            </DevForm.Button>
                        </>
                    }
                />

                <div className="mb-3">
                    <Row>
                        <Col md={5}>
                            <FormFieldGroup hideLabel={true} asRow={false}>
                                <DevForm.SelectSuggest
                                    value={formData.game_id}
                                    onChange={(data) => handleFormChange({ game_id: data?.value })}
                                    handleOptionsLoading={(inp, callback) => {
                                        if (inp.length > 1) {
                                            api_get(
                                                null,
                                                `https://${getGemHost("api")}/community/moderation_games_list?q=${inp}`,
                                                {
                                                    then: (resp) => {
                                                        const options = resp.data?.games.map((o) => {
                                                            return { value: o.id, label: o.text };
                                                        });
                                                        callback(options);
                                                    },
                                                }
                                            );
                                        }
                                    }}
                                />
                            </FormFieldGroup>
                        </Col>
                        <Col md={5}>
                            <FormFieldGroup hideLabel={true} asRow={false}>
                                <DevForm.DateRangePicker
                                    placeholder={t("Дата")}
                                    onChange={(rng) => {
                                        handleFormChange({
                                            date_added__gte: `${rng[0]} 00:00:00`,
                                            date_added__lte: `${rng[1]} 23:59:59`,
                                        });
                                    }}
                                />
                            </FormFieldGroup>
                        </Col>
                        <Col>
                            <FormFieldGroup hideLabel={true} asRow={false}>
                                <DevForm.Checkbox
                                    checked={parseInt(formData.hide_smm)}
                                    label={t("Скрыть smm")}
                                    onChange={(ev) => handleFormChange({ hide_smm: ev.target.checked ? 1 : 0 })}
                                />
                            </FormFieldGroup>
                        </Col>
                        <Col>
                            <DevForm.Button variant="primary" name="search" onClick={() => doSearch(1)}>
                                {t("Поиск")}
                            </DevForm.Button>{" "}
                        </Col>
                    </Row>
                </div>

                {apiData.data?.feed.length > 0 && (
                    <Table hover responsive className="dmg-table">
                        <thead>
                            <tr>
                                <th style={{ width: "20px" }}>
                                    <DevForm.Checkbox
                                        checked={
                                            apiData.data.feed.length ===
                                            apiData.data.feed.filter((o) => o.chosen).length
                                        }
                                        onChange={(ev) => {
                                            const newApiData = { ...apiData };
                                            newApiData.data.feed.forEach((item) => {
                                                item.chosen = ev.target.checked;
                                            });
                                            setApiData(newApiData);
                                        }}
                                    />
                                </th>
                                <th>{t("Профиль")}</th>
                                <th>{t("Игра")}</th>
                                <th>{t("Тред")}</th>
                                <th style={{ width: "450px" }}>{t("Текст")}</th>
                                <th>{t("Комментарий")}</th>
                                <th>{t("Время")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.data.feed.map((o, ind) => {
                                const local_date = new Date(o.ts * 1000).toLocaleString();
                                return (
                                    <tr key={o.post_id}>
                                        <td>
                                            <DevForm.Checkbox
                                                checked={o.chosen}
                                                onChange={(ev) => {
                                                    const newApiData = { ...apiData };
                                                    newApiData.data.feed[ind].chosen = ev.target.checked;
                                                    setApiData(newApiData);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {o.user.slug && (
                                                <>
                                                    {(commonInfo.account.is_super || commonInfo.account.moderator) && (
                                                        <a href={profileUrl + o.user.slug}>
                                                            <Awesome type="user-circle-o" color="green" />
                                                        </a>
                                                    )}{" "}
                                                    <a
                                                        href={`https://${getGemHost("profile")}/profile/${
                                                            o.user.slug
                                                        }/`}
                                                        target="_blank"
                                                    >
                                                        {o.user.nick}
                                                    </a>{" "}
                                                    {o.user.is_banned === true && (
                                                        <Badge variant="danger">заблокирован</Badge>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                        <td>
                                            <a
                                                href={`https://${communityHost}/community/game/${o.game.slug}/`}
                                                target="_blank"
                                            >
                                                {o.game.name}
                                            </a>
                                        </td>
                                        <td>
                                            <a href={`https://${communityHost}/c/${o.entity.hash}/`} target="_blank">
                                                {o.entity.data.title || o.entity.hash}
                                            </a>
                                        </td>
                                        <td>
                                            <OverflowArea y={350}>
                                                {o.entity.data.descr}
                                                <br />
                                                {"url" in o.entity.data &&
                                                    (o.entity.type === "video" ? (
                                                        <div>
                                                            [VIDEO]
                                                            <br />
                                                            <a
                                                                href={`https://${communityHost}/c/${o.entity.hash}/`}
                                                                target="_blank"
                                                            >
                                                                <img
                                                                    src={o.entity.data.poster}
                                                                    width={470}
                                                                    height={270}
                                                                />
                                                            </a>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={`https://${communityHost}/pre_470x0_resize${o.entity.data.url}`}
                                                            width={470}
                                                            height={270}
                                                        />
                                                    ))}
                                            </OverflowArea>
                                        </td>
                                        <td>
                                            {o.entity.comments_cnt > 0 ? (
                                                <Link
                                                    to={url_reverse("moderate:comments", null, {
                                                        post_hash: o.entity.hash,
                                                    })}
                                                >
                                                    {o.entity.comments_cnt}
                                                </Link>
                                            ) : (
                                                0
                                            )}
                                        </td>
                                        <td>{local_date.toLocaleString()}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </Card.Body>
            <SimplePaginator
                curPage={apiData.data?.feed.length > 0 ? formData.page : null}
                nextPage={apiData.data?.next_page}
                prevPage={apiData.data?.prev_page}
                changePage={doSearch}
            />
        </Card>
    );
}
